import { render, staticRenderFns } from "./TemplateReport.vue?vue&type=template&id=164b0ce0"
import script from "./TemplateReport.vue?vue&type=script&lang=ts"
export * from "./TemplateReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports